import { LearningItem } from '../../models/LearningItem'

export default function learningItemsWithCertificates(userLearningItems: LearningItem[]) {
  return userLearningItems.filter((learningItem) => learningItem.certificate).map((learningItem) => learningItem)
}
